import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, message } from 'antd';
import { useNavigate } from "react-router-dom";
import { sendCode, login, clearAccount } from '../../utils/api';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Turnstile, { TurnstileHandle } from "../../components/Turnstile";
import { CAPTCHA_TOKEN_REQ, logTurnstileToken } from "../../utils/turnstile";
import "./index.scss";

const Cancelar = () => {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false); // 注销确认框
  const [unavailableModalOpen, setUnavailableModalOpen] = useState(false); // 不可注销弹窗
  const [availableModalOpen, setAvailableModalOpen] = useState(false); // 可注销弹窗
  const [countdown, setCountdown] = useState(0);
  const countdownTimerRef = useRef<NodeJS.Timeout | null>(null);
  const turnstileRef = useRef<TurnstileHandle>(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  // 倒计时效果
  useEffect(() => {
    if (countdown > 0) {
      countdownTimerRef.current = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else {
      if (countdownTimerRef.current) {
        clearTimeout(countdownTimerRef.current);
      }
    }
    return () => {
      if (countdownTimerRef.current) {
        clearTimeout(countdownTimerRef.current);
      }
    };
  }, [countdown]);

  // 获取验证码
  const handleGetCode = async () => {
    if (countdown > 0) return; // 倒计时中不能点击

    const captchaToken = turnstileRef.current?.getToken?.() || "";
    logTurnstileToken(captchaToken);
    if (!captchaToken) {
      messageApi.error("Complete la verificación de seguridad");
      return;
    }
    
    if (!phone.trim()) {
      messageApi.warning({
        content: 'Ingrese el número de celular correcto',
      });
      return;
    }
    
    // 开始倒计时
    setCountdown(30);
    try {
      const res: any = await sendCode({
        hxcouj: '+54' + phone,
        [CAPTCHA_TOKEN_REQ]: captchaToken,
      });
      turnstileRef.current?.reset?.();
      if(res?.mxfj !== '200') {
        messageApi.error(res?.hjddzsj);
        setCountdown(0);
        return;
      }
    } catch (err) {
      turnstileRef.current?.reset?.();
      setCountdown(0);
      messageApi.error('Internal Server Error');
    }
  };

  // 验证表单
  const validateForm = () => {
    if (!phone.trim()) {
      messageApi.warning({
        content: 'Ingrese el número de celular correcto',
      });
      return false;
    }
    
    if (!code.trim()) {
      messageApi.warning({
        content: 'Ingrese el código de verificación correcto',
      });
      return false;
    }
    
    return true;
  };

  const showModal = () => {
    // 先验证表单
    if (validateForm()) {
      setOpen(true);
    }
  };

  const handleOk = async () => {
    setLoading(true);
    try {
      const res: any = await login({
        hxcouj: '+54' + phone,
        mxfj: code,
      });
      if( res?.mxfj === "100") {
        setLoading(false)
        setOpen(false);
        messageApi.error(res?.hjddzsj);
      }else if(res?.mxfj !== "200") {
        setOpen(false);
        setLoading(false);
        setUnavailableModalOpen(true);
        return;
      }else {
        setLoading(false);
        setOpen(false);
        setToken(res?.parseObj.zmmjddRxijw);
        // 直接传递 token，避免状态更新延迟问题
        handleAvailableModalOk(res?.parseObj.zmmjddRxijw);
      }

    } catch (err) {
    }
    // setTimeout(() => {
    //   setLoading(false);
    //   setOpen(false);
    // }, 3000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleUnavailableModalOk = () => {
    setUnavailableModalOpen(false);
  };

  const handleUnavailableModalCancel = () => {
    setUnavailableModalOpen(false);
  };

  const handleAvailableModalOk = async (accessToken?: string) => {
    try {
      // 使用传入的 token 或 state 中的 token
      const tokenToUse = accessToken || token;
      const res: any = await clearAccount({
        hxcouj: '+54' + phone,
        mxfj: code,
        zmmjddRxijw: tokenToUse,
        zqqOjkdoxwHxfj: '1',
        zqqOjkdoxw: 'v1.0.0',
        quzgbxkh: 'web',
      });
      if(res?.mxfj === '200') {
        setAvailableModalOpen(true);
        // messageApi.success('Eliminada con éxito');
        // 注销成功后跳转到首页
        // setTimeout(() => {
        //   navigate('/');
        // }, 1500);
        return;
      }else {
        // messageApi.error(res?.hjddzsj);
        // 不可注销弹窗打开
        setUnavailableModalOpen(true);
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAvailableModalCancel = () => {
    setAvailableModalOpen(false);
    navigate('/');
  };

  return (
    <div className="cancelar-container">
      {contextHolder}
      <Header variant="dark" />
      <div className="content">
        <div className="top-section">
          
          <div className="title">Aviso sobre la eliminación de la cuenta</div>
          <div className="description">
            Si ya no necesita utilizar los servicios de Pitage, puede solicitar aquí la eliminación de su cuenta.
            Una vez completada la eliminación, la cuenta no podrá volver a utilizarse.
          </div>
        </div>

        <div className="cards-section">
          <div className="card">
            <div className="card-title">1. Se requiere verificación de seguridad</div>
            <div className="card-desc">
              Para proteger la seguridad de su cuenta, a continuación realizaremos una verificación de identidad para confirmar que la operación es realizada por usted.
            </div>
          </div>
          <div className="card">
            <div className="card-title">2. La eliminación no se puede revertir</div>
            <div className="card-desc">
              Una vez eliminada la cuenta, su información personal, así como los registros de solicitudes y transacciones, serán eliminados y no podrán recuperarse.
              <br />
              <span className="blue-text">Por favor, confirme antes de continuar.</span>
            </div>
          </div>
          <div className="card">
            <div className="card-title">3. Complete primero los servicios pendientes</div>
            <div className="card-desc">
              Si su cuenta tiene préstamos pendientes o solicitudes en proceso, deberá completar dichas operaciones antes de poder eliminar la cuenta.
            </div>
          </div>
          <div className="card">
            <div className="card-title">4. Funciones limitadas durante el proceso</div>
            <div className="card-desc">
              Después de enviar la solicitud de eliminación, su cuenta entrará en proceso de cierre y algunas funciones quedarán temporalmente restringidas hasta que el proceso finalice.
            </div>
          </div>
        </div>

        <div className="verification-section">
          <div className="section-title">Verificación de seguridad</div>
          <div className="form-row">
            <div className="form-item">
              <label>Número de teléfono</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
            <div className="form-item">
              <label>Código de verificación</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  maxLength={4}
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
                <span 
                  className={`get-code-btn ${countdown > 0 ? 'disabled' : ''}`}
                  onClick={handleGetCode}
                >
                  {countdown > 0 ? `${countdown}s` : 'Obtener'}
                </span>
              </div>
            </div>
          </div>
          <div className="captcha-slot">
            <Turnstile ref={turnstileRef} />
          </div>
        </div>

        <div className="action-section">
          <button className="confirm-btn" onClick={showModal}>Confirmar cancelar</button>
        </div>
      </div>

    {/* 注销确认框 */}
      <Modal
        open={open}
        title="¿Confirmar la eliminación de la cuenta?"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" className="modal-cancel-btn" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button key="confirm" className="modal-confirm-btn" loading={loading} onClick={handleOk}>
            Confirmar
          </Button>,
        ]}
        className="delete-account-modal"
      >
        <div className="modal-content">
          <p className="modal-text">
            Una vez eliminada, su cuenta dejará de estar disponible y los datos asociados no podrán recuperarse.
          </p>
          <p className="modal-text">
            Si solo necesita suspender el uso del servicio de forma temporal, también puede decidirlo más adelante.
          </p>
        </div>
      </Modal>


      {/* 不可注销弹窗 */}
      <Modal
        open={unavailableModalOpen}
        onOk={handleUnavailableModalOk}
        onCancel={handleUnavailableModalCancel}
        footer={[
          <Button key="ok" className="modal-cancel-btn" onClick={handleUnavailableModalOk}>
            Confirmar
          </Button>,
          <Button key="cancel" className="modal-confirm-btn" onClick={handleUnavailableModalCancel}>
            Cancelar
          </Button>
        ]}
        className="delete-account-modal"
      >
        <div className="modal-content">
          <br />
          <p className="modal-text unavailable-modal-text">
            Su cuenta no cumple con los requisitos para ser eliminada.
          </p>
        </div>
      </Modal>

      {/* 可注销弹窗 */}
      <Modal
        open={availableModalOpen}
        onOk={() => handleAvailableModalOk()}
        onCancel={handleAvailableModalCancel}
        footer={[
          <Button key="cancel" className="modal-cancel-btn" onClick={handleAvailableModalCancel}>
            Cancelar
          </Button>,
          <Button key="ok" className="modal-confirm-btn" onClick={() => handleAvailableModalCancel()}>
            Confirmar
          </Button>
        ]}
        className="delete-account-modal"
      >
        <div className="modal-content">
          <br />
          <p className="modal-text available-modal-text">
            La eliminación de su cuenta se ha completado con éxito. Los servicios y beneficios asociados dejarán de estar disponibles.
          </p>
        </div>
      </Modal>
      <Footer />
    </div>
  );
};

export default Cancelar;
